import styled from "styled-components";

export const PremiumFeatureWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 0.2rem 0 1.5rem 2rem;
    flex-wrap: wrap;
`;

export const PremiumTitleWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const PremiumFeature = styled.div`
    display: flex;
    align-items: center;
    margin: 1rem 0 0 1rem;
`;

export const IconWrap = styled.span`
  width: 1.9rem;
  height: 1.9rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: solid 0.1rem #647a97;
  border-radius: 50%;
  margin-right: 1rem;
  border-width: ${(p) => (p.borderWidth ? p.borderWidth : "0.1rem")};
`;

export const PremiumTagWrap = styled.span(
    props => `
        border-radius: 0.2rem;
        color: #141823;
        font-size: 1.4rem;
        padding: 0.2rem 0.6rem;
        background-image: linear-gradient(277deg, ${props?.primaryColor ? props.primaryColor : "#f8cd46"}, ${props?.secondaryColor ? props.secondaryColor : "#f4a900"});
    `
);

export const PremiumFeatureText = styled.span`
    color: #141823;
    font-size: 1.4rem;
`;

export const FeatureImage = styled.img`
    height: 1.8rem;
    width: 1.8rem;
`;

